module.exports = __webpack_public_path__ + "static/catch-7f4c86b100f1cd813bac2c480cad0f21.jpg";